export function isGoogleSignInEnabled(
  value = import.meta.env.VITE_GOOGLE_SIGN_IN_ENABLED
) {
  return value === "true";
}

export function googleSignInErrorMessage(search) {
  const parameters = new URLSearchParams(search);
  if (!parameters.get("error")) {
    return null;
  }
  const description = parameters.get("error_description") || "";
  if (description.includes("GOOGLE_ACCOUNT_NOT_CONNECTED")) {
    return "This Google account is not linked to Workflow86. Choose another Google account or sign in with email and password.";
  }
  return "Google sign-in failed. Choose another Google account or sign in with email and password.";
}

export function removeOAuthErrorParameters(href) {
  const url = new URL(href);
  url.searchParams.delete("error");
  url.searchParams.delete("error_description");
  url.searchParams.delete("state");
  return `${url.pathname}${url.search}${url.hash}`;
}
